import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Sidebar } from "../components/Sidebar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import backgroundImage from "../assets/Profile.jpg";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
// import ProgressPopup from './ProgressBar';  // Adjust path as necessary

// ProgressBar Component
const ProgressBar = ({ progress, color }) => {
  let statusText = "";

  // Determine the status text based on the color
  if (color === "bg-blue-500") {
    statusText = "IN PROGRESS....";
  } else if (color === "bg-green-500") {
    statusText = "The Data received in your mail";
  } else if (color === "bg-red-500" && progress === 100) {
    statusText = "The process completed with warnings. Check your mail.";
  }else if (color === "bg-red-500" && progress === 90) {
    statusText = "The process completed with warnings. Check your mail.";
  }

  return (
    <div className="max-w-2xl  h-4 md:ml-[60px] rounded-full  relative flex-grow flex items-center justify-center px-4 py-8">
      <div
        className={`h-6 rounded-full transition-all duration-500 ${color}`}
        style={{ width: `${progress}%` }}
      ></div>
      {statusText && (
        <div className="absolute inset-0 flex justify-center items-center text-white font-semibold">
          {statusText}
        </div>
      )}
    </div>
  );
};

export default function Gst_Form() {
  const [formData, setFormData] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedForm, setSelectedForm] = useState("xero");
  const [showPassword, setShowPassword] = useState({});
  const [showSecurityAnswers, setShowSecurityAnswers] = useState({});
  const [idErrors, setIdErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false); // Popup state
  const navigate = useNavigate();
  // const [showMyobPopup, setShowMyobPopup] = useState(false); // MYOB popup state
  const [progress, setProgress] = useState(0);
  const [color, setColor] = useState("");

  // const [isUnstable, setIsUnstable] = useState(false);
  // const closePopup = () => setSubmissionStatus("");
  const [showProgress, setShowProgress] = useState(false); // Show/Hide progress
  const [errorMessage, setErrorMessage] = useState("");
  const [isUnstable, setIsUnstable] = useState(false); // Add this state at the top of your component
  const intervalRef = useRef(null);

  const fetchJobStatus = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        console.log("No user is signed in");
        return;
      }

      const uid = user.uid;
      const db = getFirestore();
      const userDoc = doc(db, "user", uid);
      const userSnapshot = await getDoc(userDoc);
      if (!userSnapshot.exists()) {
        console.log("No such document!");
        return;
      }

      const userPlan = userSnapshot.data().plan || "noplan";
      const formType = userSnapshot.data().formType || selectedForm; // Use stored formType or current selection

      const response = await fetch(
        "https://api-issp7n7t4a-uc.a.run.app/api/build-status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ plan: userPlan, formType }), // Include formType
        }
      );

      if (!response.ok) throw new Error("Failed to fetch build status");

      const buildData = await response.json();
      // console.log("Latest Build Status:", buildData);

      // Update build number and form type in Firestore
      await updateDoc(userDoc, {
        buildNumber: buildData.buildNumber,
        formType: selectedForm, // Store formType
      });
      // console.log("Build number and form type updated in Firestore");

      setIsUnstable(false); // Reset unstable state
    } catch (error) {
      console.error("Error fetching job status:", error);
    }
  };

  const fetchJobStatusByBuildNumber = async () => {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      await currentUser.getIdToken(true);

      if (!currentUser) return;

      const uid = currentUser.uid;
      const db = getFirestore();
      const userDoc = doc(db, "user", uid);
      const userSnapshot = await getDoc(userDoc);
      if (!userSnapshot.exists()) return;

      const buildNumber = userSnapshot.data().buildNumber;
      const userPlan = userSnapshot.data().plan || "noplan";
      const formType = userSnapshot.data().formType || selectedForm; // Use stored formType

      if (!buildNumber) return;

      const response = await fetch(
        `https://api-issp7n7t4a-uc.a.run.app/api/job-status/${buildNumber}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ plan: userPlan, formType }), // Include formType
        }
      );

      if (!response.ok) throw new Error("Failed to fetch job status");

      const buildData = await response.json();

      let buildStatus = "UNKNOWN";
      if (buildData.building) {
        buildStatus = "IN_PROGRESS";
      } else if (buildData.result === "SUCCESS") {
        buildStatus = "SUCCESS";
      } else if (buildData.result === "FAILURE") {
        buildStatus = "FAILURE";
      } else if (buildData.result === "UNSTABLE") {
        buildStatus = "UNSTABLE";
      }

      if (buildStatus === "IN_PROGRESS") {
        setProgress(0);
        setColor("bg-blue-500");

        let currentProgress = 0;
        const interval = setInterval(() => {
          currentProgress += 25;
          if (currentProgress > 100) {
            clearInterval(interval);
          } else {
            setProgress(currentProgress);
          }
        }, 1000);

        intervalRef.current = interval;
      } else {
        clearInterval(intervalRef.current);
        if (buildStatus === "SUCCESS") {
          setColor("bg-green-500");
          setProgress(100);
          setShowProgress(true); 
        } else if (buildStatus === "FAILURE") {
          setColor("bg-red-500");
          setProgress(90);
          setShowProgress(true); 
        }else if (buildStatus === "UNSTABLE") {
          setColor("bg-red-500");
          setProgress(100);
          setIsUnstable(true);
        }
      }
    } catch (error) {
      console.error("Error fetching job status:", error);
    }
  };

  // useEffect(() => {
    // fetchJobStatusByBuildNumber();
    // intervalRef.current = setInterval(fetchJobStatusByBuildNumber, 5000);

    // return () => clearInterval(intervalRef.current);
  // }, [ selectedForm]);

  const xeroFields = [
    { name: "ATO_Id", hint: "Enter ATO Email Id" },
    { name: "Client_Name", hint: "Enter client name of ATO" },
    { name: "From", hint: "Start date of the period" },
    { name: "To", hint: "End date of the period" },
    {
      name: "July_September_Quarter",
      hint: "Jul 2022 Sep 2022 Business activity statement",
    },
    {
      name: "October_December_Quarter",
      hint: "Oct 2022 Dec 2022 Business activity statement",
    },
    {
      name: "January_March_Quarter",
      hint: "Jan 2023 Mar 2023 Business activity statement",
    },
    {
      name: "April_June_Quarter",
      hint: "Apr 2023 Jun 2023 Business activity statement",
    },
    { name: "XERO_Id", hint: "Enter your Xero Email Id" },
    { name: "XERO_Password", hint: "Enter your password" },
    { name: "Security_Question_1", hint: "First security question" },
    {
      name: "Security_Answer_1",
      hint: "What is your dream job?",
    },
    { name: "Security_Question_2", hint: "Second security question" },
    {
      name: "Security_Answer_2",
      hint: "What is your dream car?",
    },
    { name: "Security_Question_3", hint: "Third security question" },
    {
      name: "Security_Answer_3",
      hint: "What was the name of your first pet?",
    },
    { name: "XERO_Client_Name", hint: "Enter Client Name of XERO" },
    { name: "User_Name", hint: "Enter your name" },
    { name: "Email_Id", hint: "Recipient of the sender" },
  ];

  const myobFields = [
    { name: "ATO_Id", hint: "Enter ATO Email Id" },
    { name: "Client_Name", hint: "Enter client name of ATO" },
    { name: "From", hint: "Start date of the period" },
    { name: "To", hint: "End date of the period" },
    {
      name: "July_September_Quarter",
      hint: "Jul 2022 Sep 2022 Business activity statement",
    },
    {
      name: "October_December_Quarter",
      hint: "Oct 2022 Dec 2022 Business activity statement",
    },
    {
      name: "January_March_Quarter",
      hint: "Jan 2023 Mar 2023 Business activity statement",
    },
    {
      name: "April_June_Quarter",
      hint: "Apr 2023 Jun 2023 Business activity statement",
    },
    { name: "MYOB_Id", hint: "Enter your MYOB Email" },
    { name: "MYOB_Password", hint: "Enter your password" },
    { name: "MYOB_Client_Name", hint: "Enter your MYOB Client Name" },
    { name: "User_Name", hint: "Username for laptop" },
    { name: "Email_Id", hint: "Recipient of the sender" },
    {
      name: "MYOB_Authentication_Code",
      hint: "Enter the MYOB Authentication Code",
    },
  ];
  useEffect(() => {
    const isNewUser = !localStorage.getItem("popup");
    if (isNewUser) {
      setShowPopup(true);
      localStorage.setItem("popup", "true");
    }
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false); // Close the popup without redirecting
  };

  // const handleFormTypeChange = (formType) => {
  //   if (formType === "myob") {
  //     setSelectedForm(formType);
  //   } else {
  //     setSelectedForm(formType); // Set the selected form
  //     handleReset();
  //   }
  // };

  // const handleMyobPopupClose = () => {
  //   setShowMyobPopup(false); // Close the MYOB popup
  //   setSelectedForm("xero"); // Reset form to Xero
  // };

  const handleGoToHelp = () => {
    setShowPopup(false);
    navigate("/help_guide"); // Redirect to help page
  };

  useEffect(() => {
    const allFieldsFilled = Object.values(formData).every(
      (value) => value !== ""
    );
    const emailValid = validateEmail(formData.Email_Id);
    const idValid = validateIdFields();

    setIsFormValid(allFieldsFilled && emailValid && idValid);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Convert date format if the field is a date
    const formattedValue =
      name === "From" || name === "To" ? formatDate(value) : value;

    setFormData({
      ...formData,
      [name]: formattedValue,
    });

    // Clear any ID error when user types
    if (idErrors[name]) {
      setIdErrors((prev) => ({ ...prev, [name]: "" }));
    }

    // Hide password and security answer fields when switching inputs
    if (name.includes("Password") || name.includes("Security_Answer")) {
      const newShowPassword = {};
      const newShowSecurityAnswers = {};

      // Hide all password and security answer fields
      for (const field of Object.keys(formData)) {
        if (field.includes("Password")) {
          newShowPassword[field] = false;
        }
        if (field.includes("Security_Answer")) {
          newShowSecurityAnswers[field] = false;
        }
      }

      setShowPassword(newShowPassword);
      setShowSecurityAnswers(newShowSecurityAnswers);
    }
  };

  // Helper function to format date from yyyy-mm-dd to dd/mm/yyyy
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  // Helper function to format date for the input (dd/mm/yyyy to yyyy-mm-dd)
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateIdFields = () => {
    const idFields = ["ATO_Id", "XERO_Id", "Myob_Id", "Email_Id"];
    let isValid = true;
    const newIdErrors = {};

    for (let field of idFields) {
      if (formData[field] && !validateEmail(formData[field])) {
        newIdErrors[field] = `Please enter a valid email for ${field}.`;
        isValid = false;
      }
    }

    setIdErrors(newIdErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validateEmail(formData.Email_Id)) {
      toast.error("Please enter a valid email address.");
      return;
    }
  
    // Show loading toast
    const submittingToastId = toast.info("Submitting...", { autoClose: false });
    setIsLoading(true);
  
    const auth = getAuth();
    const firestore = getFirestore();
    const currentUserUid = auth.currentUser ? auth.currentUser.uid : null;
  
    if (!currentUserUid) {
      toast.dismiss(submittingToastId);
      toast.error("User is not authenticated.");
      setIsLoading(false);
      return;
    }
  
    try {
      const userDocRef = doc(firestore, "user", currentUserUid);
      const userDocSnap = await getDoc(userDocRef);
  
      if (!userDocSnap.exists()) {
        throw new Error("User document not found in Firestore.");
      }
  
      const userData = userDocSnap.data();
      const userEmail = userData.email;
  
      const response = await fetch(
        "https://api-issp7n7t4a-uc.a.run.app/api/runJenkinsJob",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            formData,
            formType: selectedForm,
            userEmail: userEmail,
          }),
        }
      );
  
      const responseText = await response.text();
  
      if (response.ok) {
        toast.success(responseText || "Job triggered successfully!", {
          autoClose: 2000,
        });
        setSubmissionStatus("Submission successful");
  
        setTimeout(() => {
          toast.info("ATO verification code has been sent to your Mail");
        }, 60000);
      } else {
        toast.error(`Failed to trigger job: ${responseText}`);
        setSubmissionStatus("Submission failed");
      }
    } catch (error) {
      console.error("Error occurred:", error.message);
      toast.error(`Error occurred: ${error.message}`);
      setSubmissionStatus("Submission error");
    } finally {
      // Always dismiss the loading toast
      toast.dismiss(submittingToastId);
      setIsLoading(false);
    }
  };
  

  const handleReset = () => {
    setFormData({});
    setSubmissionStatus("");
    setIdErrors({});
    setShowPassword({});
    setShowSecurityAnswers({});
  };

  const getFields = () => {
    return selectedForm === "xero" ? xeroFields : myobFields;
  };

  const formatFieldName = (fieldName) => {
    return fieldName
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handlePasswordVisibility = (fieldName) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName] || false, // Ensure it defaults to false if undefined
    }));
  };

  const handleSecurityAnswerVisibility = (fieldName) => {
    setShowSecurityAnswers((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName] || false, // Ensure it defaults to false if undefined
    }));
  };

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    width: "100vw", // Ensures it covers the full width
    overflowX: "hidden", // Hides horizontal scrolling
  };

  const formStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
  };

  const labelStyle = {
    fontWeight: "bold",
  };

  return (
    <div
      className="flex flex-col min-h-screen bg-white w-full max-w-full overflow-hidden"
      style={backgroundStyle}
    >
      <Sidebar />
      <ToastContainer />
      <div className="flex items-center md:ml-[250px] mt-2 justify-between w-full">
        {/* Show/Hide Buttons on the Left Side */}
        <div className="flex ">
          {!showProgress ? (
            <button
              onClick={() => setShowProgress(true)}
              className="px-2 py-2 rounded text-white bg-gray-900"
            >
              Show Progress
            </button>
          ) : (
            <button
              onClick={() => setShowProgress(false)}
              className="px-2 py-2 rounded text-white bg-gray-500"
            >
              Hide Progress
            </button>
          )}
        </div>

        {/* Progress Bar on the Right Side */}
        {showProgress && (
          <div className="flex-grow ml-auto">
            <ProgressBar progress={progress} color={color} />
          </div>
        )}
      </div>

      <div className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-4xl bg-white p-8 " style={formStyle}>
          <h1 className="text-2xl font-bold text-center mb-6">
            {selectedForm === "xero"
              ? "Xero GST Reconciliation Form"
              : "MYOB GST Reconciliation Form"}
          </h1>

          <div className="flex justify-center mb-6">
            <div className="flex items-center mx-4" style={labelStyle}>
              <input
                type="radio"
                id="xero"
                name="formType"
                value="xero"
                checked={selectedForm === "xero"}
                onChange={() => {
                  setSelectedForm("xero");
                  handleReset();
                }}
                className="mr-2 text-black"
              />
              <label htmlFor="xero" className="text-black">
                {" "}
                Xero
              </label>
            </div>
            <div className="flex items-center mx-4" style={labelStyle}>
              <input
                type="radio"
                id="myob"
                name="formType"
                value="myob"
                checked={selectedForm === "myob"}
                onChange={() => {
                  setSelectedForm("myob");
                  handleReset();
                }}
                className="mr-2"
              />
              <label htmlFor="myob" className="text-black">
                MYOB
              </label>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {getFields().map((fieldObj, index) => (
                <div key={index} className="flex flex-col relative">
                  <label
                    className="block text-sm font-full text-black mb-1"
                    style={labelStyle}
                  >
                    {formatFieldName(fieldObj.name)}
                  </label>
                  {fieldObj.name === "From" || fieldObj.name === "To" ? (
                    <input
                      type="date"
                      name={fieldObj.name}
                      value={formatDateForInput(formData[fieldObj.name]) || ""}
                      onChange={handleChange}
                      placeholder={fieldObj.hint}
                      className="p-2 block w-full border border-gray-400 rounded-md"
                      required
                    />
                  ) : fieldObj.name.toLowerCase().includes("password") ? (
                    <div className="relative">
                      <input
                        type={showPassword[fieldObj.name] ? "text" : "password"}
                        name={fieldObj.name}
                        value={formData[fieldObj.name] || ""}
                        onChange={handleChange}
                        placeholder={fieldObj.hint}
                        className="p-2 block w-full border border-gray-400 rounded-md"
                        required
                      />
                      <button
                        type="button"
                        onMouseEnter={() =>
                          handlePasswordVisibility(fieldObj.name)
                        }
                        onMouseLeave={() =>
                          handlePasswordVisibility(fieldObj.name)
                        }
                        className="absolute inset-y-0 right-0 px-3 flex items-center"
                      >
                        {showPassword[fieldObj.name] ? (
                          <FaEye className="w-5 h-5 text-gray-600" />
                        ) : (
                          <FaEyeSlash className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                    </div>
                  ) : fieldObj.name
                      .toLowerCase()
                      .includes("security_answer") ? (
                    <div className="relative">
                      <input
                        type={
                          showSecurityAnswers[fieldObj.name]
                            ? "text"
                            : "password"
                        }
                        name={fieldObj.name}
                        value={formData[fieldObj.name] || ""}
                        onChange={handleChange}
                        placeholder={fieldObj.hint}
                        className="p-2 block w-full border border-gray-400 rounded-md"
                        required
                      />
                      <button
                        type="button"
                        onMouseEnter={() =>
                          handleSecurityAnswerVisibility(fieldObj.name)
                        }
                        onMouseLeave={() =>
                          handleSecurityAnswerVisibility(fieldObj.name)
                        }
                        className="absolute inset-y-0 right-0 px-3 flex items-center"
                      >
                        {showSecurityAnswers[fieldObj.name] ? (
                          <FaEye className="w-5 h-5 text-gray-600" />
                        ) : (
                          <FaEyeSlash className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                    </div>
                  ) : (
                    <div className="flex flex-col">
                      <input
                        type="text"
                        name={fieldObj.name}
                        value={formData[fieldObj.name] || ""}
                        onChange={handleChange}
                        placeholder={fieldObj.hint}
                        className="p-2 block w-full border border-gray-400 rounded-md"
                        required
                      />
                      {idErrors[fieldObj.name] && (
                        <span className="text-red-500 text-sm mt-1">
                          {idErrors[fieldObj.name]}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="flex justify-between">
              <button
                type="submit"
                className={`py-2 px-4 ${
                  isFormValid
                    ? "bg-blue-500 text-white"
                    : "bg-blue-200 text-gray-600"
                } rounded`}
                disabled={!isFormValid || isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
              <button
                type="button"
                onClick={handleReset}
                className="py-2 px-4 bg-gray-500 text-white rounded"
              >
                Reset
              </button>
            </div>
          </form>

          {/* {submissionStatus && (
      <ProgressPopup
        progress={progress}
        submissionStatus={submissionStatus}
        onClose={closePopup}
      />
    )} */}
        </div>
      </div>
      {showPopup && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-30 flex justify-center items-center">
          <div className="bg-black p-4 sm:p-6 rounded-md shadow-md w-full max-w-xs sm:max-w-md">
            <h2 className="text-lg sm:text-xl text-white font-semibold mb-3 sm:mb-4">
              Need Help?
            </h2>
            <p className="mb-3 sm:mb-4 text-white text-sm sm:text-base">
              It looks like you're new here. Would you like to visit the User
              guide?
            </p>
            <div className="flex justify-end space-x-2 sm:space-x-4">
              <button
                className="bg-blue-500 text-white px-3 sm:px-4 py-1 sm:py-2 rounded hover:bg-blue-700"
                onClick={handleGoToHelp}
              >
                User guide
              </button>
              <button
                className="bg-gray-500 text-white px-3 sm:px-4 py-1 sm:py-2 rounded hover:bg-gray-700"
                onClick={handlePopupClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* {showMyobPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center">
          <div className="bg-black p-4 sm:p-6 rounded-md shadow-md w-full max-w-xs sm:max-w-md">
            <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4 text-white">
              Feature Pending
            </h2>
            <p className="mb-3 sm:mb-4 text-sm sm:text-base text-white">
              MYOB form integration is pending and will be added in a future
              version.
            </p>
            <div className="flex justify-end space-x-2 sm:space-x-4">
              <button
                className="bg-blue-500 text-white px-3 sm:px-4 py-1 sm:py-2 rounded hover:bg-blue-700"
                onClick={handleMyobPopupClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}
